/**
 * Created by Oles on 4/28/2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {I18n} from 'react-redux-i18n';
import ActionsButton from '@common/components/ActionsButton';

export class TestResultRow extends Component {

    constructor(props) {
        super(props);
        var locale = window.navigator.userLanguage || window.navigator.language;
        moment.locale(locale);

        this.menuItems = [
            { onClick: props.showTestDetails, label: I18n.t('viewTestDetails') },
            { onClick: props.onTestDelete, label: I18n.t('deleteTest') }
        ]
    }


    render () {
        var docs = this.props.documents.map(document => {
            return <i key={document.id}
                      className="fa fa-file-pdf-o"
                      aria-hidden="true"
                      style={{color: '#008dce', paddingRight: '2px', cursor: 'pointer'}}
                      data-toggle="tooltip"
                      data-placement="top"
                      title={document.fileName}
                      onClick={e => {
                          if (document.url) {
                              this.props.openDocumentByUrl(document.url);
                          } else {
                              this.props.onDocSelected(document.id);
                          }
                      }
                      }
                    ></i>;
        });
        const { setCurrent } = this.props;

        return (
            <tr>
                <td style={{display: 'inline-block', paddingRight: '0px', width: '60px'}}>
                    <ActionsButton id={this.props.id} menuItems={this.menuItems} setCurrent={setCurrent} />
                </td>
                <td style={{width: this.props.columns[1].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}}>{this.props.lab}</td>
                <td style={{width: this.props.columns[2].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}}><a style={{cursor: 'pointer'}} onClick={e => this.props.onViewDetails(this.props.id)}>{this.props.testOrdered}</a></td>
                <td style={{width: this.props.columns[3].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}}>{this.props.submittedDate ? moment(this.props.submittedDate).format('L') : ''}</td>
                <td style={{width: this.props.columns[4].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}}>{this.props.reportedDate ? moment(this.props.reportedDate).format('L') : ''}</td>
                <td style={{width: this.props.columns[5].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}}>{this.props.reclassDate ? moment(this.props.reclassDate).format('L') : ''}</td>
                <td style={{width: this.props.columns[6].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}}>{this.props.testStatus}</td>
                <td style={{width: this.props.columns[7].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}} title={this.props.result}>{this.props.result}</td>
                <td style={{width: this.props.columns[8].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}}>{docs}</td>
                <td style={{width: this.props.columns[9].width + 'px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'inline-block', paddingRight: '0px'}}>{this.props.notes}</td>
            </tr>
        )
    }
}

TestResultRow.PropTypes = {
    id: PropTypes.number.isRequired,
    submittedDate: PropTypes.string,
    reportedDate: PropTypes.string,
    reclassDate: PropTypes.string,
    lab: PropTypes.string,
    testOrdered: PropTypes.string,
    testStatus: PropTypes.string,
    result: PropTypes.string,
    notes: PropTypes.string,
    onViewDetails: PropTypes.func.isRequired,
    showTestDetails: PropTypes.func.isRequired,
    onTestDelete: PropTypes.func.isRequired,
};